<template>
  <section class="pd-t-10">
    <div class="container" v-if="tasks.length > 0">
      <div class="d-flex align-items-center ">
        <h2>{{ comp.task }}</h2>
        <!-- <router-link
          :to="{
            name: $store.state.app.activeGroup.publicPage.route,
            params: {
              id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0].id,
              cid: 0
            }
          }"
          class="mg-l-auto btn btn-secondary btn-uppercase btn-xs"
        >
          Бүх сургалтыг үзэх
          <feather type="arrow-right" class="mg-l-5"></feather>
        </router-link> -->
      </div>

      <div class="row">
        <div
          @click="$emit('on-tsk-info', t)"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
          v-for="(t, i) in tasks"
          :key="i"
          role="button"
        >
          <div class="card best-courses mg-b-30">
            <div class="card-body pd-0">
              <div
                :style="
                  `background-image: url('${t.defaultAttachmentUrl}?w=350&h=200&mode=crop')`
                "
                class="ht-200 cvr"
              ></div>
              <!-- <img    :src="`${t.defaultAttachmentUrl}?w=450&h=200&mode=crop`" class="wd-100p cvr" /> -->
            </div>
            <div class="card-footer pd-t-20 bg-white">
              <div class="text-center bd-b mg-b-20 pd-b-10">
                <h5>{{ t.task }}</h5>
              </div>
              <div class="d-flex stts">
                <!-- Оролцогчийн лимит Хугацаа хоног-->
                <!-- <div><feather type="users" class="mg-r-5"></feather>{{t.i7==1?t.i1:'Хязгааргүй'}}</div> -->
                <!-- <div>
                  <feather type="calendar" class="mg-r-5"></feather
                  >{{ t.flag == 9 ? t.i2 : getDuration(t) }}<sup>хон</sup>
                </div> -->
                <div class="mg-l-auto">
                  <!-- {{ t.budget | formatMoney(0, ".", ",") }} ₮ -->
                  {{ t.locTypeName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container pd-y-100 tx-center">
      <div
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
          Сургалт хоосон байна
        </h1>
        <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">
          [{{ type.name }}] ангилалд хараахан нээлттэй сургалт зарлагдаагүй
          байна.
        </h5>
        <p class="tx-color-03 mg-b-30">
          Та сургалтууд хэсгээс өөрт тохирох сургалтыг сонгон суралцана уу.
        </p>
        <div class="d-flex mg-b-40">
          <router-link
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: {
                id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0]
                  .id,
                cid: 0
              }
            }"
            class="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25 text-white"
            >Бүх сургалтыг үзэх</router-link
          >
        </div>
      </div>
    </div>

    <div
      style="background: #444"
      v-if="$store.state.app.activeGroup.id == 9254"
    >
      <div class="container pd-y-40-f">
        <div
          style="color: white; font-size: 26px; font-style: italic"
          class="text-center"
        >
          Засгийн газрын Хэрэг эрхлэх газар, Дэлхийн банкны санхүүжилтээр
          <br />"Ухаалаг засаг" төслийн хүрээнд энэхүү Цахим сургалтын
          платформыг нэвтрүүлэв.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";
const moment = require("moment");

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      type: {}
    };
  },
  mounted() {
    this.loadTasks();
  },
  methods: {
    loadTasks() {
      let sizes = 40;
      if (this.$store.state.app.pages.filter(x => x.st1 == "courses").length) {
        if (
          this.$route.params.id ==
          this.$store.state.app.pages.filter(x => x.st1 == "courses")[0].id
        ) {
          sizes = 40;
        }
      }

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: sizes,
          ot: 560,
          model: {
            isPublic: true,
            locTypeId:
              this.$route.params.cid != 0 ? this.$route.params.cid : null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (res.data.tasks.length > 0) this.tasks = res.data.tasks;
          //else this.typeDetail();
        }
      });
    },
    getDuration(t) {
      var start = moment(t.createdDate);
      var due = moment(t.dueDate);
      return due.diff(start, "days");
    },
    typeDetail() {
      request({
        api: { method: "GET", url: "type/GetInheritedDetail" },
        params: {
          id: this.$route.params.cid,
          key: "courseType"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.type = res.data;
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.loadTasks();
        });
      }
    }
  }
};
</script>

<style lang="scss">
.best-courses {
  border: none;
  box-shadow: 2px 3px 7px rgb(163 177 198 / 50%);
  border: 20px;
  .card-body {
    border-radius: 10px 10px 0 0;
    .cvr {
      border-radius: 10px 10px 0 0;
      background-size: cover;
      background-position: center;
    }
  }
  .card-footer {
    .stts {
      border-radius: 0 0 20px 20px;
    }
  }
}
</style>
